import React from "react"
import createTemplate from "../../create-template"

import { useComponents } from "../../components"

function PeasleyThankYou({ styles, ...props }) {
  const Elements = useComponents()

  return (
    <Elements.LandingPage
      styles={styles}
      {...props}
      style={styles.forElement("page")}
    >
      <div
        className="formkit-page-header"
        style={{
          backgroundColor: styles.forElement("first_background").backgroundColor
        }}
      >
        <div
          className="formkit-header-background"
          style={styles.forElement("first_background")}
        />
        <div className="formkit-container">
          <Elements.Content
            name="preheading"
            defaults={{
              content: "Free webinar"
            }}
          />
          <div className="formkit-border" style={styles.forElement("border")} />
          <Elements.Heading
            name="heading"
            defaults={{
              content: "Thank you for signing up!"
            }}
          />
          <Elements.Region className="formkit-subheading" name="subheading">
            <Elements.Content
              defaults={{
                content:
                  "Import follow up message about what user can expect in the coming days."
              }}
            />
          </Elements.Region>
          <Elements.Event
            group="date"
            name="date"
            className="formkit-date"
            style={styles.forElement("date")}
          />
        </div>
      </div>
      <div
        className="formkit-page-content"
        style={{
          backgroundColor: styles.forElement("second_background")
            .backgroundColor
        }}
      >
        <div
          className="formkit-content-background"
          style={styles.forElement("second_background")}
        />
        <div className="formkit-container formkit-container--narrow">
          <Elements.Heading
            className="formkit-content-heading"
            group="content_heading"
            name="content_heading"
            tag="h2"
            defaults={{
              content: "Follow up message"
            }}
          />
          <Elements.Region
            className="formkit-content"
            group="content_body"
            name="content_body"
          >
            <Elements.Content
              defaults={{
                content:
                  "More information about your video or video series can go in here. Describe in more details the content and the benefits for the subscriber signing up to receive your videos in their inbox. More information about your video or video series can go in here. More information about your video or video series can go in here."
              }}
            />
          </Elements.Region>
        </div>
      </div>
      <div
        className="formkit-form-section"
        style={{
          backgroundColor: styles.forElement("third_background").backgroundColor
        }}
      >
        <div
          className="formkit-footer-background"
          style={styles.forElement("third_background")}
        />
        <div className="formkit-container formkit-container--narrow">
          <Elements.Image
            className="formkit-image"
            name="image"
            size={{ w: 118, h: 118 }}
            aspectRatio={1}
            shape="circle"
          />
          <Elements.Heading
            className="formkit-name"
            name="bio_heading"
            tag="h3"
            defaults={{
              content: "John Smith"
            }}
          />
          <Elements.Region className="formkit-bio" name="bio_content">
            <Elements.Content
              defaults={{
                content:
                  "Short bio about you so that potential subscribers can get to know a little about you."
              }}
            />
          </Elements.Region>
          <Elements.BuiltWith
            background="third_background"
            image="third_background"
          />
        </div>
      </div>
    </Elements.LandingPage>
  )
}

PeasleyThankYou.style = "landing_page"
PeasleyThankYou.categories = ["Event", "Newsletter", "Profile", "Waitlist"]
PeasleyThankYou.thumbnail = ""
PeasleyThankYou.preview = "https://demo.ck.page/peasley"
PeasleyThankYou.fields = [
  {
    name: "first_name",
    label: "First name"
  },
  {
    name: "email_address",
    label: "Email"
  }
]

export default createTemplate(PeasleyThankYou, { name: "PeasleyThankYou" })
